import { Alert } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';

export function DownloadKsyosDesktopLink() {
    const organizationId = useSelector((state: IReduxState) => state.authentication.organizationId);

    return (
        <Alert.Link
            rel="noreferrer"
            target="_blank"
            to={`/desktop?organizationId=${organizationId}`}
            variant="link"
        >
            Download de Ksyos koppeling.
        </Alert.Link>
    );
}
